import { ComponentType } from '@angular/cdk/overlay';
import { smartString } from '@r1-compass-library/utilities';

export const TopLevelRoutes = [
    {
        path: 'plays',
        claim: '/play*',
    },
    {
        path: 'template-criteria',
        claim: '/template-criteria*',
    },
    {
        path: 'lifecycle-rules',
        claim: '/lifecycle-rule*',
    },
    {
        path: 'content-library',
        claim: '/content-library*',
    },
    {
        path: 'division-settings',
        claim: '/division-settings*',
    },
    {
        path: 'admin-settings',
        claim: '/admin-settings*',
    },
    {
        path: 'login',
        claim: '/login',
    },
    {
        path: 'user-settings',
        claim: '/user-settings*',
    },
    { path: 'reports', claim: '/reporting*' },
] as const;

export type CompassRoute = {
    path: (typeof TopLevelRoutes)[number]['path'] | smartString;
    sidenavLinkTitle: string;
    containerTitle: string;
    /**
     * @description `path` is used when possible to handle section validation logic. But if the `path`
     * is not convenient, specify a `sectionKey` in camel case.
     */
    sectionKey?: string;
    excludeFromValidation?: boolean;
    component: ComponentType<unknown>;
};

export type CompassRouteParent = {
    path: (typeof TopLevelRoutes)[number]['path'];
    component: CompassRoute['component'];
    children: CompassRoute[];
    mainTitle: string;
};
